export class QrModal {
  private root: HTMLDivElement;
  private resolveClose: (() => void) | null = null;

  constructor(host: HTMLElement) {
    this.root = document.createElement('div');
    this.root.className = 'layer qrm ignore-aim hidden';
    this.root.innerHTML = `
      <div class="qrm-card">
        <div class="qrm-head">
          <div class="qrm-title">扫码上手机</div>
          <button class="qrm-close" aria-label="关闭">×</button>
        </div>
        <div class="qrm-body">
          <img class="qrm-img" src="/qr-local.png" alt="QR Code" />
          <p class="qrm-hint">用手机扫码，与同一 WiFi 下的开发机上的本作对接。<br/>正式部署后请用 <code>node scripts/gen-qr.mjs &lt;URL&gt;</code> 重新生成。</p>
        </div>
      </div>
    `;
    host.appendChild(this.root);
    this.root.querySelector('.qrm-close')?.addEventListener('click', () => this.close());
  }

  open(): Promise<void> {
    return new Promise(resolve => {
      this.resolveClose = resolve;
      this.root.classList.remove('hidden');
      requestAnimationFrame(() => this.root.classList.add('show'));
    });
  }

  close(): void {
    this.root.classList.remove('show');
    setTimeout(() => {
      this.root.classList.add('hidden');
      this.resolveClose?.();
      this.resolveClose = null;
    }, 220);
  }
}
